const navigation = {
    admin: 'Administration',
    anomalies: 'Anomalies',
    activityDashboard: 'Activity dashboard',
    dashboard: 'Dashboard',
    documents: 'Documents',
    search: 'Search',
    uploadDocument: 'Upload Document',
    drbfm: 'DRBFM',
    verification: 'Design Verification',
    cadViewer: '3D CAD Viewer',
    settings: 'Settings',
    help: 'Help',
    profile: 'Profile',
    logout: 'Logout',
    logoutConfirm: {
      title: 'Log out',
      description: 'Any unsaved input on this page will be lost. Are you sure you want to log out?',
      confirm: 'Log out',
    },
    toggleSidebar: 'Toggle sidebar',
    workspaceSection: 'Workspace',
    toggleChat: 'Toggle AI chat',
    notifications: 'Notifications',
    resizeChat: 'Resize chat panel',
  };

export default navigation;
